export default __webpack_public_path__ + "static/benefitSectionBg-c001bcd7cc5e18e6d1ff61efa214d648.png";